<template>
  <div
    class="flex-1 border-t border-t-border first:border-t-0 tablet:border-t-0 tablet:!pt-0 not-first:pt-4"
  >
    <div class="text-size-6 font-bold">{{ title }}</div>
    <BlokkliField
      name="field_paragraphs"
      :list="filterNullArray(paragraphs)"
      class="mt-4 flex flex-wrap items-center gap-5"
    />
  </div>
</template>

<script lang="ts" setup>
import type { ParagraphLogoListFragment } from '#graphql-operations'
import { filterNullArray } from '~/helpers'

defineProps<ParagraphLogoListFragment>()

defineBlokkli({
  bundle: 'logo_list',
  globalOptions: ['bkHiddenGlobally'],
  propsFieldMapping: {
    title: {
      type: 'editable',
      name: 'field_title',
    },
    paragraphs: { type: 'field', name: 'field_paragraphs' },
  },
})
</script>
